  <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-6">
                <div class="card">
                    <!-- Logo -->
                    <!-- <div class="card-header pt-4 pb-4 text-center bg-primary">
                        <a href="index.html">
                            <span><img src="assets/images/logo.png" alt="logo" height="22"></span>
                        </a>
                    </div> -->

                    <div class="card-body">

                        <div class="text-center">
                            <img src="assets/images/svg/startman.svg" height="120" alt="File not found Image">

                            <h3 class="text-error mt-4">{{errorStatus[errorCode]?.title || 'Error'}}</h3>
                            <h4 class="text-uppercase text-danger mt-3">{{errorStatus[errorCode]?.message || 'Something went wrong with the system'}}</h4>

                            <button class="btn btn-primary mt-3" (click)="goHome()"><i class="mdi mdi-reply"></i> Return Home</button>
                        </div>

                    </div> <!-- end card-body-->
                </div>
                <!-- end card-->

            </div> <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</div>
